module.exports = __webpack_public_path__ + "img/khmer_women.996bd47c.png";